import type { Optional, SetRequiredAndNonNullable } from '@festina-life/core'
import type { FPlusViewerAlignment } from '@festina-life/fplus'

import type { FPlusExpressionValue } from '../../types/templateModel'
import {
  FormattedFPlusViewer,
  OVERFLOW_LINE_WIDTH,
} from '../formattedFPlusViewer/FormattedFPlusViewer'
import { LiteralExpressionViewer } from './LiteralExpressionViewer'
import { LiteralExpressionWithOverflowViewer } from './LiteralExpressionWithOverflowViewer'
import type { ExpressionTypeInformation, LiteralTypeInformation } from './types'

type Props = {
  expression: Optional<FPlusExpressionValue>
  path: string
  label?: string
  alignment: FPlusViewerAlignment
  isShowingFunctionDeclaration: boolean
  overflowTitle?: Optional<string>
  typeInformation?: Optional<ExpressionTypeInformation>
  shouldShowOverflowFallback: boolean
}

export const FPlusViewerContents = ({
  expression,
  alignment,
  isShowingFunctionDeclaration,
  path,
  overflowTitle,
  typeInformation,
  shouldShowOverflowFallback,
}: Props) => {
  if (typeInformation?.type === 'literal' && !!typeInformation.value) {
    const nonNullableTypeInformation =
      typeInformation as SetRequiredAndNonNullable<
        LiteralTypeInformation,
        'value'
      >

    return shouldShowOverflowFallback ? (
      <LiteralExpressionWithOverflowViewer
        typeInformation={nonNullableTypeInformation}
        alignment={alignment}
      />
    ) : (
      <LiteralExpressionViewer
        typeInformation={nonNullableTypeInformation}
        alignment={alignment}
      />
    )
  }

  return (
    <FormattedFPlusViewer
      isShowingFunctionDeclaration={isShowingFunctionDeclaration}
      shouldShowOverflowFallback={shouldShowOverflowFallback}
      alignment={alignment}
      code={expression?.fplusSource ?? ''}
      expressionPath={path}
      overflowTitle={overflowTitle}
      tooltipLineLength={OVERFLOW_LINE_WIDTH}
    />
  )
}
